import React, { useState, useEffect, useContext } from 'react';
import { GetData } from './Fetch';
import DropDown from './DropDown';
import { TranslationContext, SettingsContext } from "./Context";

function VehicleBrowser(props) {

    const translation = useContext(TranslationContext);
    const settings = useContext(SettingsContext);
    const [manufacturers, setManufacturers] = useState([]);
    const [models, setModels] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [manuOption, setManuOption] = useState(null);
    const [modelOption, setModelOption] = useState(null);
    const [vehicleOption, setVehicleOption] = useState(null);

    useEffect(() => {
        GetData(`/language/${settings.language}/country/${settings.market}/manufacturers/${props.linkingTargetType}`)
            .then(data => {
                setManufacturers(data);
            });
    },[]);

    function handleManufacturerSelection(e) {
        setManuOption(e);
        setModelOption(null);
        setVehicleOption(null);
        setModels([]);
        setVehicles([]);
        props.onVehicleSelected(null)

        if (e === null) {
            return;
        }
        
        const manuId = Number.parseInt(e.value);
        const manufacturer = manufacturers.find(m => m.manuId === manuId);
        GetData(`/language/${settings.language}/country/${settings.market}/manufacturers/${manufacturer.targetType}/${manufacturer.manuId}/models`)
            .then(data => {
                setModels(data);
            });
    }

    function handleModelSelection(e) {
        setModelOption(e);
        setVehicleOption(null);
        setVehicles([]);
        props.onVehicleSelected(null)
        if (e === null) {
            return;
        }

        const modelId = Number.parseInt(e.value);
        const model = models.find(m => m.modelId === modelId);
        const manufacturer = manufacturers.find(m => m.manuId === manuOption.value);
        GetData(`/language/${settings.language}/country/${settings.market}/manufacturers/${manufacturer.targetType}/${manufacturer.manuId}/models/${model.modelId}`)
            .then(data => {
                setVehicles(data);
            });
    }

    function handleVehicleSelection(e) {
        setVehicleOption(e);
        if (e === null) {
            props.onVehicleSelected(null);
            return;
        }

        const carId = Number.parseInt(e.value);
        const selectedVehicle = vehicles.find(v => v.carId === carId);
        props.onVehicleSelected(selectedVehicle)
    }

    const createOptions = (items, create) => {
        const result = [];
        items.map(x => result.push(create(x)));
        return result;
    };

    const createModelOptions = (items, create) => {
        const result = [];
        items.map(x => {

            let label = `${x.modelname} / ${x.yearOfConstrFrom} - `;
            if (Number.isInteger(x.yearOfConstrTo)) {
                label += x.yearOfConstrTo;
            }
            const item = { value: x.modelId, label: label }

            result.push(item)
        });
        return result;
    };

    return (
        <div className="row">
            
            <div className="col-md-6">
                <DropDown onChange={handleManufacturerSelection} id='manufacturer' label={translation["TecAlliencePartSearch.PartsSearch.Browse.Manufacturer"] + " *"}
                    options={createOptions(manufacturers, (x) => ({ value: x.manuId, label: x.manuName }))}
                    value={manuOption}
                ></DropDown>
            </div>

            <div className="col-md-6">
                <DropDown onChange={handleModelSelection} id='model' label={translation["TecAlliencePartSearch.PartsSearch.Browse.Model"] + " *"}
                    options={createModelOptions(models)}
                    value={modelOption}
                ></DropDown>
            </div>

            <div className="col-xs-12">
                <DropDown onChange={handleVehicleSelection} id='type' label={translation["TecAlliencePartSearch.PartsSearch.Browse.Type"] + " *"}
                    options={createOptions(vehicles, (x) => ({ value: x.carId, label: props.onFormatTypeDisplayValue(x) }))}
                    value={vehicleOption}
                >
                </DropDown>
            </div>

        </div>
    );
}

export default VehicleBrowser;